/**
 * UranIA PA — `/accessibilita` (dichiarazione di accessibilità).
 *
 * Pagina istituzionale nuova (Riordino della mappa delle rotte §3/§4/§7,
 * Rilascio A passo A.7). "I testi legali arrivano dal committente: non
 * inventare dichiarazioni di accessibilità né informative privacy —
 * placeholder espliciti, marcati come da redigere." La rotta esiste (con
 * guscio e struttura); il contenuto no.
 */

import { useTranslation } from 'react-i18next';
import { createRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { InstitutionalPageShell, PendingNotice } from '../features/sistema/InstitutionalPageShell.tsx';
import { Route as PubblicoRoute } from './_pubblico.tsx';

function AccessibilitaPage(): JSX.Element {
  const { t } = useTranslation();
  return (
    <InstitutionalPageShell
      badge={t('istituzionale.accessibilita.badge')}
      title={t('istituzionale.accessibilita.title')}
      testId="accessibilita-page"
    >
      <PendingNotice body={t('istituzionale.accessibilita.pending_body')} />
    </InstitutionalPageShell>
  );
}

export const Route = createRoute({
  getParentRoute: () => PubblicoRoute,
  path: '/accessibilita',
  component: AccessibilitaPage,
});
